export enum RuntimeEnvironment {
  E2E = 'e2e',
  HML = 'hml',
  LOCAL = 'local',
  PRD = 'prd',
  TEST = 'test',
}
